export default "__VITE_ASSET__DjgmcAVD__"